import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { contactTypeService } from "../shared/api/contactType";

interface Props {
	contactTypeId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const ContactTypeListContextMenu: FC<Props> = ({ contactTypeId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => contactTypeService.showUsage(contactTypeId).then((r) => r.data.data),
		[contactTypeId],
	);

	const canUpdate = useHasPermission<PermissionName>(["contactType.update"]);
	const canDelete = useHasPermission<PermissionName>(["contactType.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Contact type")}
						confirmationBody={t("Are you sure you want to delete this contact type?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
